module.exports = __webpack_public_path__ + "static/img/loginrnd.db8c7c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/loginrnd.jpg
// module id = 1409
// module chunks = 0